/**
 * MUI Dialog / Modal component overrides.
 */
import { Components, Theme } from "@mui/material/styles";

export const dialogOverrides: Pick<Components<Theme>, "MuiModal"> = {
  MuiModal: {
    styleOverrides: {
      root: {
        ".MuiPaper-root": {
          borderRadius: "20px"
        },
        ".MuiDialogTitle-root": {
          paddingTop: 24
        },
        ".MuiDialogContent-root": {
          paddingBottom: 24
        }
      }
    }
  }
};
